<template>
  <!-- <div class="domainHotWords-wrap">
    <h1>领域热词: <br />事件概括、各方解释</h1>
    <h1>量化指标：<br />技术类型、产业类型、发展类型等指标</h1>
  </div> -->
  <div class="domainHotWords-wrap">
     <div class="search-wrap">
      <el-input type="text" placeholder="请输入热词进行搜索" v-model="searchdata" @keyup.enter.native="btnSearch" show-word-limit>
      </el-input>
      <el-button type="primary" @click="btnSearch" class="btn-wrap">搜索</el-button>
      </div>
      <div style=" width:100%;height:calc(100% - 20px);display:flex; overflow:hidden">
         <div class="hot-website"  v-show="informationflag">
            <div style="font-size:20px;padding: 15px;font-family:仿宋;font-weight:bold;text-align:center;">热词资讯</div>
            <div v-for="item,index in hotWordWebsite.slice(0,50)" :key="item.index" class="hotWordWebsite">
              <a @click="openNewpage(item)" style="width:250px;white-space:nowrap;
              overflow:hidden;text-overflow:ellipsis;
              color:#E5068C;" >{{index+1}}、{{item}}</a>
            </div>
          </div>
         <div id="main" ref="container"></div>
          <div class="hot-word">
            <div style="font-size:20px;padding: 15px;font-family:仿宋;font-weight:bold;text-align:center;">热词热度排行</div>
            <div v-for="item,index in hotWordList.slice(0,10)" :key="item.index" class="hotWordList">
              <div>{{index+1}}、{{item[0]}}</div>
              <div style="color:orange"><i class="el-icon-user-solid"></i>{{item[1]}}</div>
            </div>
          </div>
      </div>
   
  </div>
  
</template>

<script>
import WordCloud from "wordcloud";
import CONSTANCE from "@/static/js/constance";
import { request } from "@/utils/request";
import api from "@/services/api";
export default {
  data(){
      return{
        searchdata: "",
        timer: null,
        hotWordList:[],
        hotWordWebsite:[],
        informationflag:false,
      }
  },
  mounted() {
    console.log(111);
    // eslint-disable-next-line no-undef
    console.log(api.regions.list({ page_size: 300, page_to: 1 }).response);
    request.wordClouding
      .create({
        domain_id: "海洋信息" === this.$store.getters.getSystemType ? 1 : 2, // todo: 用map动态获取
        // region_id: 1,
        // category_code: "1.",
        top_n: 100,
      })
      .then((res) => {
        let max = Math.max(...res.data.data.map((x) => x.value));
        const list = res.data.data.map((data) => {
          const { word, value } = data;
          return [word, Math.floor((value * CONSTANCE.WORD_CLOUD_SIZE) / max)];
        });
        this.hotWordList = list
        WordCloud(this.$refs.container, {
          list: list,
        });
      });
  },
  methods: {
    openNewpage(item){
       window.open(item);
    },
    btnSearch() {
      const params = { 
        "target_hot_word":this.searchdata
      }
      api.region_information.hot_word_searching(params).response.then((res) => res.data).then((res) =>{
        if(res.code == 200) {
          if(res.data.link == "该词非热词,请重新检索..."){
            this.$message.warning(res.data.link) 
            return
          }
          this.hotWordWebsite = res.data.link
          this.informationflag = true
        }
      })
    },
    searchEnterFun(e) {
       if(!this.searchdata){
        return
      }
      this.$emit('searchEnter',e,this.searchdata)
    }
  }
};
</script>

<style lang="scss" scoped>
.domainHotWords-wrap {
  width:calc(100% - 40px) ;
  height:calc(100% - 40px) ;
  padding: 20px;
  overflow: hidden;
  .hot-word{
    overflow: hidden;
    width: 20%;
    margin-top: 20px;
    height: calc(100% - 60px) ;
    // background: rgb(29, 174, 203);
    // text-align: center;
    .hotWordList{
      color:white;
      font-size:17px;
      padding:15px;
      display:flex;
      justify-content:space-between
    }
  }
  .hot-website{
    overflow-y: auto;
    width: 20%;
    margin-top: 20px;
    height: calc(100% - 60px) ;
     box-shadow: 0 0 1.5em rgb(188 230 236 / 50%) inset;
    background-color: #212a4b;
    border-radius: 5px;
    .hotWordWebsite{
      color:red;
      padding:15px;
      display:flex;
      justify-content:space-between;
      font-size:14px;
      width:300px;
    }
  }
}
#main {
  width: 60%;
  height: calc(100% - 60px) ;
  background-color: transparent 
  !important;
  // visibility: hidden;
}
.search-wrap {
  width:70% ;
  margin: 20px auto;
  display: flex;
  flex-wrap: nowrap;

  //   .button-wrap {
  //     width: 80px;
  //     line-height: 50px;
  //     border-radius: 42px;
  //     background: linear-gradient(225deg, #0c09cf, #0e0bf6);
  //     box-shadow: -18px 18px 35px #0a07aa, 18px -18px 35px #100dff;
  //   }
  .btn-wrap {
    margin-left: 5px;
    font-weight: bold;
    background-color: rgb(7, 22, 116);
    border-color: rgb(7, 22, 116);
    //   text-align: justify;   // 未生效
  }
}
</style>
